<template>
  <div>
    <b-form-group label="Профсоюз">
      <b-form-select
        v-model="value.union_id"
        :options="unionsOptions"
        required
      ></b-form-select>
    </b-form-group>
    <b-form-group label="Профгруппа">
      <b-form-select
        v-model="value.professional_group_id"
        :options="professionalGroupsOptions"
        required
      ></b-form-select>
    </b-form-group>
    <b-form-group label="Дата вступления">
      <datepicker v-model="value.join_date" button-variant="primary" />
    </b-form-group>
    <b-form-group label="Дата выхода">
      <datepicker v-model="value.leave_date" button-variant="primary" />
    </b-form-group>
  </div>
</template>

<script>
import Datepicker from "@/components/Datepicker";
import UnionMemberModel from "@/components/Forms/Person/models/unionMemberModel";
import { mapGetters } from "vuex";

export default {
  components: {
    Datepicker
  },
  props: {
    value: {
      type: UnionMemberModel,
      required: true,
      default: () => new UnionMemberModel()
    }
  },
  computed: {
    ...mapGetters("professionalGroups", ["actualProfessionalGroups"]),
    ...mapGetters("unions", {
      unions: "actualUnions"
    }),
    professionalGroupsOptions: ({ actualProfessionalGroups, unionId }) => {
      return [
        {
          text: "Нет",
          value: null
        },
        ...actualProfessionalGroups
          .filter(group => Number(group.union_id) === Number(unionId))
          .map(group => ({ text: group.name, value: group.id }))
      ];
    },
    unionsOptions: ({ unions }) => {
      return unions.map(union => ({ text: union.name, value: union.id }));
    },
    unionId: ({ value }) => value.union_id
  }
};
</script>
